
export default class PrivacyPolicyStatusOutputData {
    constructor(data) {
        this.agreed = data.agreed;
        this.kind = data.kind;
        this.url = data.url;
        this.version = data.version;
    }
}